module.exports = __webpack_public_path__ + "img/img_flow_time2.60b82fc7.png";